import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RequestService } from '../../../features/requets/shared/request.service';
import { FileUpload } from '../../../features/requets/shared/model/file-upload.model';

@Component({
  selector: 'app-uploadfile-dialog',
  templateUrl: './uploadfile-dialog.component.html',
  styleUrls: ['./uploadfile-dialog.component.scss']
})
export class UploadfileDialogComponent implements OnInit {

  archivoAdjunto: String;
  extension: String;
  pathArchivo: String;
  cedula: String;
  dataBase64: any;
  codigoPrueba: String;
  messageError: String = '';
  enabledSpinner = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private requestService: RequestService,
              public dialogRef: MatDialogRef<UploadfileDialogComponent>) {
                  this.cedula = data.cedula;
                  this.codigoPrueba = data.codigo;
              }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(null);
  }


   onFilesAdded(files) {
    const reader = new FileReader();
    const file = files[0];
    reader.readAsDataURL(file);
    try {
      reader.onload = () => {
        this.dataBase64 = reader.result;
        this.archivoAdjunto = file.name;
        const splitName = this.archivoAdjunto.split('.');
        this.extension =  splitName[splitName.length - 1];
      };
    } catch (e) {
      this.messageError = 'No se pudo cargar archivo, intente con otro!';
    }
  }
  sendSelect() {
    this.uploadFile(this.dataBase64, this.archivoAdjunto, this.codigoPrueba, this.extension);
  }

  private uploadFile(data, nombre, codigoPrueba, extension) {
    const file = new FileUpload();
    file.codigoPrueba = codigoPrueba;
    file.cedula = this.cedula;
    file.codigo = data;
    file.extension = extension;
    this.enabledSpinner = true;
    this.requestService.uploadFile(file).subscribe(
      (result) => {
        this.enabledSpinner = false;
        if (result.data) {
           const resultRest = result.data.split('-');
          if (resultRest[0] === 'OK') {
            this.archivoAdjunto =  nombre;
            this.pathArchivo = resultRest[1];
            const dataReturn = { fileName: this.archivoAdjunto , path : this.pathArchivo};
            this.dialogRef.close(dataReturn);

          } else {
            this.messageError = result.data;
          }
        }
      }
    );
  }
}
